export function getLocalizedCategoryName(cat: any, locale: string, fallback?: string): string {
  if (!cat) return fallback || ''
  switch (locale) {
    case 'zh-CN': return cat.cn || cat.name
    case 'zh-TW': return cat.tw || cat.name
    case 'en': return cat.en || cat.name
    case 'ko': return cat.kr || cat.name
    default: return cat.name // ja
  }
}
